import { LastModifiedCell } from 'ui/indexPages/tables/cells/LastModifiedCell';

import {
  WorkflowCreatorOrModifierUser,
  WorkflowReferenceData,
  WorkflowTimestampData,
  WorkflowUserData,
} from '../../types';

type WorkflowLastModifiedData = WorkflowTimestampData & WorkflowUserData & WorkflowReferenceData;

type WorkflowLastModifiedCellProps = {
  workflow: WorkflowLastModifiedData;
  creatorAndModifierUsersById: Record<string, WorkflowCreatorOrModifierUser>;
};

const determineLastModified = (workflow: WorkflowLastModifiedData) => {
  if (
    !!workflow?.workflowReference &&
    workflow?.workflowReference?.updatedAt > workflow?.updatedAt
  ) {
    return {
      updatedAt: workflow?.workflowReference?.updatedAt,
      userId: workflow?.workflowReference?.updatedByUserId,
    };
  }
  return { updatedAt: workflow?.updatedAt, userId: workflow?.updatedByUserId };
};

export const WorkflowLastModifiedCell = ({
  workflow,
  creatorAndModifierUsersById,
}: WorkflowLastModifiedCellProps) => {
  const lastModified = determineLastModified(workflow);
  const creator = creatorAndModifierUsersById[workflow.creatorUserId];
  const createdBy = {
    emailAddress: workflow.creatorUserId,
    ...creator,
  };

  let modifiedBy;
  if (lastModified.userId) {
    const modifier = creatorAndModifierUsersById[lastModified.userId];
    modifiedBy = {
      emailAddress: lastModified.userId,
      ...modifier,
    };
  }
  return (
    <LastModifiedCell
      createdBy={createdBy}
      modifiedBy={modifiedBy}
      createdAt={workflow.createdAt}
      modifiedAt={lastModified.updatedAt}
    />
  );
};
